/* Viva La Vulva — conversion quick wins (Nov 2026). Loaded from snippets/js-bridge.liquid.
 *  1. Cart drawer: upsell shown below the cart items; on mobile the PADA box is compact.
 *  2. Cart page: upsell moved below the cart; on mobile a Checkout button right under the items.
 *  3. Mobile product pages: sticky Add to Cart bar while the real button is off screen.
 *  4. BIRTHGIFT sign-ups under $65: "$X more for your free Birth Comb" line under the shipping bar.
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 767px)');
  var COMB_VARIANT_ID = 44969199010089, KIT_VARIANT_ID = 47677694574889, COMB_AT = 6500;
  var cart = null;

  var css = document.createElement('style');
  css.textContent =
    '@media (max-width:767px){' +
      '.gg-partial-prompt .gg-container{padding:8px 10px!important;gap:8px!important;align-items:center}' +
      '.gg-partial-prompt .gg-prompt p,.gg-partial-prompt .gg-prompt-message{font-size:12px!important;line-height:1.35!important}' +
      '.gg-partial-prompt .gg-prompt-message{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}' +
      '.gg-partial-prompt .gg-button-container button{min-height:36px!important;padding:6px 12px!important}' +
      '.gg-partial-prompt{margin-bottom:8px!important}' +
    '}' +
    // Drawer: items first, then the upsell, then the cart questions.
    '.max-h-full.h-screen form#cart{display:flex;flex-direction:column}' +
    '.max-h-full.h-screen form#cart>div:has(>ul){display:contents}' +
    '.max-h-full.h-screen form#cart>div:has(>ul)>ul{order:1;padding-top:16px;border-top:1px solid currentColor}' +
    '.max-h-full.h-screen form#cart>div:has([data-essential-upsell-funnel-id]){order:2;margin-top:12px}' +
    '.max-h-full.h-screen form#cart>div:has(>ul)>:not(ul){order:3;padding-bottom:48px}' +
    '.vlv-quick-checkout{margin:16px 0 8px;display:none}' +
    '@media (max-width:767px){.vlv-quick-checkout{display:block}}' +
    '.vlv-quick-checkout .vlv-qc-sub{display:flex;justify-content:space-between;font-size:15px;margin-bottom:10px}' +
    '.vlv-quick-checkout button{width:100%;border:0;border-radius:999px;background:#EC008C;color:#fff;font-weight:700;font-size:16px;padding:14px 16px;letter-spacing:.5px;cursor:pointer}' +
    '.vlv-comb-step{margin:6px 0 10px;padding:8px 12px;border-radius:10px;background:#F9D3E5;color:#5E444B;font-size:13px;line-height:1.35;text-align:center}' +
    '.vlv-comb-step b{color:#EC008C}' +
    '.vlv-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:40;background:#fff;border-top:2px solid #F9D3E5;padding:10px 16px calc(10px + env(safe-area-inset-bottom));display:flex;align-items:center;gap:12px;transform:translateY(110%);transition:transform .25s ease;box-shadow:0 -6px 18px rgba(0,0,0,.08)}' +
    '.vlv-sticky-atc.is-on{transform:none}' +
    '.vlv-sticky-atc .vlv-sa-name{flex:1;min-width:0;font-size:13px;line-height:1.25;color:#5E444B;overflow:hidden;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical}' +
    '.vlv-sticky-atc button{flex:none;border:0;border-radius:999px;background:#EC008C;color:#fff;font-weight:700;font-size:14px;padding:12px 18px;white-space:nowrap;cursor:pointer}' +
    // Klaviyo "Free birth comb" teaser: small pill bottom-left on mobile, lifted above the sticky bar when it shows.
    '[class*="kl-teaser-"]{transition:transform .25s ease}' +
    '@media (max-width:767px){' +
      '[class*="kl-teaser-"]{width:auto!important;margin:0!important;left:12px!important;bottom:12px!important;filter:drop-shadow(rgba(0,0,0,.18) 0 2px 8px)!important}' +
      '[class*="kl-teaser-"] [role="button"]{border-radius:999px!important;min-height:0!important;padding:7px 14px!important}' +
      '[class*="kl-teaser-"] p,[class*="kl-teaser-"] p span{font-size:13px!important;line-height:1.2!important}' +
      'body.vlv-sticky-on [class*="kl-teaser-"]{transform:translateY(-66px)!important}' +
    '}' +
    '@media (min-width:768px){.vlv-sticky-atc{display:none}}';
  (document.head || document.documentElement).appendChild(css);

  function money(c) { return '$' + (c / 100).toFixed(2); }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }
  function eligible() {
    try { var m = JSON.parse(localStorage.getItem('vlvGiftCode') || 'null'); if (m && m.code === 'BIRTHGIFT' && Date.now() - m.at < 30 * 864e5) return true; } catch (e) {}
    if (cart && (cart.discount_codes || []).some(function (d) { return /^BIRTHGIFT/i.test(d.code); })) return true;
    return /(?:^|;\s*)discount_code=[^;]*BIRTHGIFT/i.test(document.cookie);
  }

  // ---- 1 + 2: move the cart upsell below the cart items (drawer + cart page)
  function placeUpsell() {
    // Drawer: handled in CSS above (the app re-renders its block if it is moved).
    // Cart page: the upsell is its own section above the cart section.
    if (/\/cart\/?$/.test(location.pathname)) {
      var host = document.querySelector('essential-upsell-product-addon-app-block');
      var upSec = host && host.closest('.shopify-section');
      var cartSec = document.querySelector('.shopify-section[id$="__cart"]');
      if (upSec && cartSec && cartSec.nextElementSibling !== upSec && upSec.compareDocumentPosition(cartSec) & Node.DOCUMENT_POSITION_FOLLOWING) {
        cartSec.insertAdjacentElement('afterend', upSec);
      }
    }
  }

  // ---- 2: Checkout button right under the items on the mobile cart page
  function quickCheckout() {
    if (!/\/cart\/?$/.test(location.pathname) || !cart || !cart.item_count) return;
    var cartSec = document.querySelector('.shopify-section[id$="__cart"]');
    var list = cartSec && cartSec.querySelector('form#cart ul');
    if (!list) return;
    var box = cartSec.querySelector('.vlv-quick-checkout');
    if (!box) {
      box = document.createElement('div');
      box.className = 'vlv-quick-checkout';
      box.innerHTML = '<div class="vlv-qc-sub"><span>Subtotal</span><strong data-vlv-qc-total></strong></div>' +
        '<button type="submit" name="checkout" form="cart">Check out</button>';
      list.insertAdjacentElement('afterend', box);
    }
    var t = box.querySelector('[data-vlv-qc-total]');
    if (t) t.textContent = money(cart.total_price);
  }

  // ---- 4: free Birth Comb step under the shipping bar
  function combStep() {
    var hosts = [];
    Array.prototype.forEach.call(document.querySelectorAll('.vlv-fs-bar'), function (b) { hosts.push(b); });
    var fsApp = document.querySelector('.order-value-booster-block');
    if (fsApp) hosts.push(fsApp.closest('.shopify-section') || fsApp);
    var msg = '';
    if (cart && eligible()) {
      var other = 0, kit = false;
      (cart.items || []).forEach(function (i) {
        if (i.variant_id === KIT_VARIANT_ID) kit = true;
        if (i.variant_id !== COMB_VARIANT_ID) other += i.original_line_price;
      });
      if (!kit && other > 0 && other < COMB_AT) msg = 'You’re <b>' + money(COMB_AT - other) + '</b> away from your <b>free Birth Comb</b>';
    }
    hosts.forEach(function (h) {
      var el = h.nextElementSibling && h.nextElementSibling.classList.contains('vlv-comb-step') ? h.nextElementSibling : null;
      if (!msg) { if (el) el.remove(); return; }
      if (!el) { el = document.createElement('div'); el.className = 'vlv-comb-step'; h.insertAdjacentElement('afterend', el); }
      if (el.innerHTML !== msg) el.innerHTML = msg;
    });
  }

  // ---- 3: sticky Add to Cart on mobile product pages
  function sticky() {
    if (!/\/products\//.test(location.pathname)) return;
    var real = document.querySelector('.add-to-cart-btn');
    if (!real || document.querySelector('.vlv-sticky-atc')) return;
    var name = (document.querySelector('h1') || {}).textContent || '';
    var bar = document.createElement('div');
    bar.className = 'vlv-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="vlv-sa-name"></div><button type="button" tabindex="-1"></button>';
    bar.querySelector('.vlv-sa-name').textContent = name.split(/\s[–—-]\s/)[0].trim();
    var btn = bar.querySelector('button');
    function label() {
      var t = (real.innerText || '').replace(/\s+/g, ' ').trim();
      var price = (t.match(/\$[\d,.]+/) || [''])[0];
      btn.textContent = real.disabled ? 'Sold out' : ('Add to cart' + (price ? ' · ' + price : ''));
      btn.disabled = !!real.disabled;
    }
    label();
    btn.addEventListener('click', function () { if (!real.disabled) real.click(); });
    document.body.appendChild(bar);
    function update() {
      var rr = real.getBoundingClientRect();
      var realVisible = rr.width > 0 && rr.bottom > 0 && rr.top < window.innerHeight;
      var drawerOpen = !!document.querySelector('[data-cart-footer]') && [...document.querySelectorAll('[data-cart-footer]')].some(function (f) { var r = f.getBoundingClientRect(); return r.width > 0 && r.left < window.innerWidth && r.right > 0 && r.top < window.innerHeight; });
      var on = MOBILE.matches && !realVisible && !drawerOpen;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('vlv-sticky-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      btn.tabIndex = on ? 0 : -1;
    }
    update();
    window.addEventListener('scroll', function () { update(); }, { passive: true });
    window.addEventListener('resize', function () { update(); });
    new MutationObserver(function () { label(); }).observe(real, { childList: true, subtree: true, characterData: true, attributes: true });
    setInterval(update, 800);
  }

  function run() { placeUpsell(); quickCheckout(); combStep(); }
  var t, busy = false;
  function refresh() { if (busy) return; busy = true; getCart().then(run).catch(function () {}).finally(function () { busy = false; }); }
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { run(); }, 120); })
    .observe(document.documentElement, { childList: true, subtree: true });
  ['shapes:modalcart:afteradditem', 'shapes:modalcart:cartqtychange'].forEach(function (ev) {
    window.addEventListener(ev, function () { setTimeout(refresh, 400); });
    document.body && document.body.addEventListener(ev, function () { setTimeout(refresh, 400); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cart-item-key], [name="add"], .add-to-cart-btn, [data-vlv-discount]')) setTimeout(refresh, 1200);
  });
  function start() { refresh(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
